// src/routes/AppRoutes.js
import React, {useContext} from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../components/HomePage';
import ContactPage from '../components/ContactPage/ContactPage';
import LoginPage from '../components/LoginPage';
import NewPostPage from '../components/NewPostPage/NewPostPage';
import RegisterPage from "../components/RegisterPage";
import AccountPage from '../components/AccountPage';
import PostsPage from '../components/PostsPage/PostsPage';
import ContentPage from '../components/ContentPage';

import ProtectedRoute from './ProtectedRoute';
import { AuthContext } from '../AuthContext';

function AppRoutes() {
  const { isLoggedIn, user } = useContext(AuthContext);
  const userClaims = user?.operationClaims || []; // array of strings

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/posts/:postId" element={<ContentPage />} />
      <Route path="/posts" element={<PostsPage />} />

      <Route
        path="/new-post"
        element={
          <ProtectedRoute
            isLoggedIn={isLoggedIn}
            userClaims={userClaims}
            requiredClaims={['createPost']}
          >
            <NewPostPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
